import React from "react";
import DepartmentOverview from "../../Components/Departments/DepartmentOverview/DepartmentOverview.component";

function Departments(props) {
  return <DepartmentOverview params={props.match.params} />;
}

export default Departments;
